// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/images/background.jpg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.login-page-container {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___}); 
  height: 100vh;
  width: 100%;
  background-size: cover;
  background-position: center;
  display: flex;
  justify-content: center;
  align-items: center;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;
}
 
.login-form-card {
  width: 440px;
  padding: 40px 50px;
  border-radius: 24px;
  background: rgba(255, 255, 255, 0.15);  
  backdrop-filter: blur(12px);           
  -webkit-backdrop-filter: blur(12px);    
  border: 1.5px solid rgba(255, 255, 255, 0.2);
  display: flex;
  flex-direction: column;
}

.login-header {
  text-align: center;
  margin-bottom: 35px;
}
.login-header p {
  margin: 0;
  font-size: 16px;
  color: #4A5568;  
}
.login-header h1 {
  margin: 4px 0 0 0;
  font-size: 40px;
  font-weight: 700;
  color: #2D3748;  
}

.form-group {
  margin-bottom: 22px;
}
.form-group label {
  display: block;
  font-size: 14px;
  font-weight: 600;
  color: #2D3748;
  margin-bottom: 8px;
}
.form-group input {
  width: 100%;
  padding: 14px 20px;
  font-size: 16px;
  color: #2D3748;
  background-color: #FFFFFF;
  border: 1px solid #E2E8F0;
  border-radius: 12px;
  box-sizing: border-box; 
}
.form-group input::placeholder {
  color: #A0AEC0;
}
.form-group input:focus {
  outline: none;
  border-color: #4299E1;
  box-shadow: 0 0 0 1px #4299E1;
}
 
.password-input-wrapper {
  position: relative;
}
.password-toggle-icon {
  position: absolute;
  top: 50%;
  right: 15px;
  transform: translateY(-50%);  
  height: 20px;
  width: 20px;
  cursor: pointer;
  opacity: 0.6;
}

.forgot-password-container {
  text-align: right;
  margin-top: -12px; 
  margin-bottom: 25px;
}
.forgot-password-container a {
  font-size: 14px;
  color: #4A5568;
  text-decoration: none;
  font-weight: 500;
}
.forgot-password-container a:hover {
  text-decoration: underline;
}

.login-button {
  width: 100%;
  padding: 15px;
  border: none;
  border-radius: 12px;
  background-color: #F97316;  
  color: #FFFFFF;
  font-size: 18px;
  font-weight: bold;
  cursor: pointer;
  transition: background-color 0.3s ease;
}
.login-button:hover {
  background-color: #EA580C;  
}
.login-button:disabled {
  background-color: #FDBA74; /* A lighter, disabled orange */
  cursor: not-allowed;
}

/* Error message style */
.login-error-message {
  color: #c53030;
  background-color: #fed7d7;
  border: 1px solid #f56565;
  border-radius: 8px;
  padding: 10px;
  font-size: 14px;
  text-align: center;
  margin-bottom: 20px;
}

@media (max-width: 600px) {
  .login-header h1 { font-size: 28px; }
  .form-group input { font-size: 14px; padding: 10px 12px; }
  .login-button { padding: 10px; }
}`, "",{"version":3,"sources":["webpack://./src/pages/LoginPage/LoginPage.css"],"names":[],"mappings":"AAAA;EACE,yDAA2D;EAC3D,aAAa;EACb,WAAW;EACX,sBAAsB;EACtB,2BAA2B;EAC3B,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,uGAAuG;AACzG;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,qCAAqC;EACrC,2BAA2B;EAC3B,mCAAmC;EACnC,4CAA4C;EAC5C,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,SAAS;EACT,eAAe;EACf,cAAc;AAChB;AACA;EACE,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,yBAAyB;EACzB,yBAAyB;EACzB,mBAAmB;EACnB,sBAAsB;AACxB;AACA;EACE,cAAc;AAChB;AACA;EACE,aAAa;EACb,qBAAqB;EACrB,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,2BAA2B;EAC3B,YAAY;EACZ,WAAW;EACX,eAAe;EACf,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,cAAc;EACd,qBAAqB;EACrB,gBAAgB;AAClB;AACA;EACE,0BAA0B;AAC5B;;AAEA;EACE,WAAW;EACX,aAAa;EACb,YAAY;EACZ,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,eAAe;EACf,sCAAsC;AACxC;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB,EAAE,+BAA+B;EAC1D,mBAAmB;AACrB;;AAEA,wBAAwB;AACxB;EACE,cAAc;EACd,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,eAAe;EACf,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB,eAAe,EAAE;EACpC,oBAAoB,eAAe,EAAE,kBAAkB,EAAE;EACzD,gBAAgB,aAAa,EAAE;AACjC","sourcesContent":[".login-page-container {\n  background-image: url('../../assets/images/background.jpg'); \n  height: 100vh;\n  width: 100%;\n  background-size: cover;\n  background-position: center;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;\n}\n \n.login-form-card {\n  width: 440px;\n  padding: 40px 50px;\n  border-radius: 24px;\n  background: rgba(255, 255, 255, 0.15);  \n  backdrop-filter: blur(12px);           \n  -webkit-backdrop-filter: blur(12px);    \n  border: 1.5px solid rgba(255, 255, 255, 0.2);\n  display: flex;\n  flex-direction: column;\n}\n\n.login-header {\n  text-align: center;\n  margin-bottom: 35px;\n}\n.login-header p {\n  margin: 0;\n  font-size: 16px;\n  color: #4A5568;  \n}\n.login-header h1 {\n  margin: 4px 0 0 0;\n  font-size: 40px;\n  font-weight: 700;\n  color: #2D3748;  \n}\n\n.form-group {\n  margin-bottom: 22px;\n}\n.form-group label {\n  display: block;\n  font-size: 14px;\n  font-weight: 600;\n  color: #2D3748;\n  margin-bottom: 8px;\n}\n.form-group input {\n  width: 100%;\n  padding: 14px 20px;\n  font-size: 16px;\n  color: #2D3748;\n  background-color: #FFFFFF;\n  border: 1px solid #E2E8F0;\n  border-radius: 12px;\n  box-sizing: border-box; \n}\n.form-group input::placeholder {\n  color: #A0AEC0;\n}\n.form-group input:focus {\n  outline: none;\n  border-color: #4299E1;\n  box-shadow: 0 0 0 1px #4299E1;\n}\n \n.password-input-wrapper {\n  position: relative;\n}\n.password-toggle-icon {\n  position: absolute;\n  top: 50%;\n  right: 15px;\n  transform: translateY(-50%);  \n  height: 20px;\n  width: 20px;\n  cursor: pointer;\n  opacity: 0.6;\n}\n\n.forgot-password-container {\n  text-align: right;\n  margin-top: -12px; \n  margin-bottom: 25px;\n}\n.forgot-password-container a {\n  font-size: 14px;\n  color: #4A5568;\n  text-decoration: none;\n  font-weight: 500;\n}\n.forgot-password-container a:hover {\n  text-decoration: underline;\n}\n\n.login-button {\n  width: 100%;\n  padding: 15px;\n  border: none;\n  border-radius: 12px;\n  background-color: #F97316;  \n  color: #FFFFFF;\n  font-size: 18px;\n  font-weight: bold;\n  cursor: pointer;\n  transition: background-color 0.3s ease;\n}\n.login-button:hover {\n  background-color: #EA580C;  \n}\n.login-button:disabled {\n  background-color: #FDBA74; /* A lighter, disabled orange */\n  cursor: not-allowed;\n}\n\n/* Error message style */\n.login-error-message {\n  color: #c53030;\n  background-color: #fed7d7;\n  border: 1px solid #f56565;\n  border-radius: 8px;\n  padding: 10px;\n  font-size: 14px;\n  text-align: center;\n  margin-bottom: 20px;\n}\n\n@media (max-width: 600px) {\n  .login-header h1 { font-size: 28px; }\n  .form-group input { font-size: 14px; padding: 10px 12px; }\n  .login-button { padding: 10px; }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
